import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect,Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import { format} from 'date-fns';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import {Row} from 'react-bootstrap';

import { URL_IMG} from '../../configs/urlConfigs';
import { SCROLL_PAGING_CREW_AVAILABILITY_COUNT,CREW_MAX_RATING,LOGIN_AFFILIATE_GROUP, ENUM_MM5, ENUM_SHIFT_LENGTH_HHMM,SHIFT_STATUS} from '../../configs/staticConfigs';
import { LBL_APP_NAME,LBL_TIME,LBL_SELECT,LBL_SHIFT_LENGTH,LBL_SEARCH,LBL_END_DATE,LBL_START_DATE,LBL_CREW_AVAILABILITY, LBL_SKILLS, LBL_DEPARTMENTS,LBL_PAY_LEVELS,LBL_SHIFT_STATUS} from '../../configs/labelConfigs';
import { MSG_NO_DEPT_SKILL_SELECTED,MSG_CREW_AVAILABILITY_NOT_FOUND} from '../../configs/msgConfigs';

import CustomMultiSelect from '../commons/helpers/customMultiSelect';

import * as types from '../../actions';
import { serverTimeAction} from '../../actions/commonActions';
import { crewAffSkillListAction} from '../../actions/crewActions';
import { aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import { payLevelsListAction} from '../../actions/settings/affiliates/payLevelsActions';
import { crewAvailSummaryReportListAction} from '../../actions/eventActions';

import { userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import { converDateToLocal,convertDecimalToHHMM} from '../../utils/commonUtilities';
import { titleCase} from '../../utils/changeCase';
import { checkNumColon} from '../../utils/validation';

const MSG_DEFAULT_CREW_LIST = MSG_CREW_AVAILABILITY_NOT_FOUND;
class CrewAvailSummaryReportComponent extends Component {

    constructor(props){
        super(props)
        this.state = { 
            departmentsList: [],
            deptMultiSelList: [],
            selectedDepartments:[],
            skillMultiList:[],
            errorMessage:'',
            availabilitySummary:[],
            hasMore:false,
            startDate:format(new Date(), 'yyyy-MM-dd')+" 00:00:00",
            defaultStartDate:format(new Date(), 'yyyy-MM-dd')+" 00:00:00",
            endDate:format(new Date(), 'yyyy-MM-dd')+" 00:00:00",
            defaultEndDate:format(new Date(), 'yyyy-MM-dd')+" 00:00:00",
            startTime:'00:00',
            endTime:'08:00',
            skillIds:[],
            departmentIds:[],
            shiftLength:'08:00',
            currentPage:1,
            perPageCount:SCROLL_PAGING_CREW_AVAILABILITY_COUNT,
            payLevelMultiSelList: [],
            payLevelListAll: [],
            selectedPayLevels: [], 
        }
    }

    loadMultiSelDeptValues() {
        let allDept = []; 
        let selectedDepartments = [];
        if(this.state.departmentsList.length > 0) {
           let tmpObj = {}; 
           let len = this.state.departmentsList.length; 
           let deptId = 0;  
           this.state.departmentsList.forEach((item,index) => { 
              tmpObj = {value:item.id, label:titleCase(item.name), inputVal:0}; 
              allDept.push(tmpObj);
           }) 
           
            this.setState({deptMultiSelList:allDept},()=>{                
                this.sendFilterData();
            }); 
        }
     }

    onskillDataChange = (selectedStatus) =>{
        let skillIds = [];
        selectedStatus.forEach((item) => {
            skillIds.push(parseInt(item.value,10));
        });
        this.setState({skillIds:skillIds});
    }

    handleChangeMultiSel = (selectedDepts) =>{
        let actUserDept = []; 
        selectedDepts.forEach((item) => {
           actUserDept.push(item.value);
        }); 
        this.setState({selectedDepartments:actUserDept}); 
    }

    onChangePayLevelMultiSel = (selectedPLs) =>{
        let actPLs = []; 
        selectedPLs.forEach((item) => {
           actPLs.push(item.value);
        }); 
        this.setState({selectedPayLevels:actPLs}); 
    } 


    onStartDateChange = (date) =>{
        let { startDate, endDate} = this.state;
        if(date==='' || date===null){
            startDate = format(this.state.defaultStartDate, 'yyyy-MM-dd')+" 00:00:00";
        }else{
            startDate = format(new Date(date), 'yyyy-MM-dd')+" 00:00:00";
        }
        endDate = startDate
        this.setState({startDate, endDate},()=>{
            this.calculateEndDateAndTime();
        });
         
           
    }
    onHandleChangeStartTime = (time) =>{
        let {startTime} = this.state;    
        if(time._d !== undefined){
            startTime = format(new Date(time._d), 'HH:mm');           
            this.setState({startTime});
        }
    }
    onBlurStartTime = (time) =>{
        let {startTime} = this.state;
        if(time._d !== undefined){
            startTime = format(new Date(time._d), 'HH:mm');
            
        }else{
            try{
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                var s = time.trim();
                var parts = s.match(/(\d+)\:(\d+)/);
                if(parts == null && s.slice(-1) == ":"){
                    parts = s.match(/(\d+)\:/)
                    hours = parseInt(parts[1], 10);
                    minutes = 0;
                }else{
                    hours = parseInt(parts[1], 10);
                    minutes = parseInt(parts[2], 10);
                }
                
                d.setHours(hours);
                d.setMinutes(minutes);
                startTime = format(d, 'HH:mm');
            }catch(err) {
                var hours = 0;
                if(s && s.indexOf(':')==-1 && !isNaN(s)){
                    hours = parseInt(s, 10);
                }
                
                var minutes = 0;
                var d = new Date();
                d.setHours(hours);
                d.setMinutes(minutes);
                startTime = format(d, 'HH:mm');
                this.setState({startTime});
            }
        } 
        this.setState({startTime}, () => {
            this.calculateEndDateAndTime();

        });
                
    }
    calculateEndDateAndTime=()=>{
        let {startDate, startTime, shiftLength, endDate, endTime} = this.state;
        let startDate_tmp = startDate;
        if(startDate === ''){
            startDate_tmp = new Date();
        }else{
            if(typeof(startDate_tmp) == "string" && startDate_tmp.split('T').length > 1){
                // startDate_tmp = new Date(startDate_tmp.split('T')[0]+" 00:00:00");
                startDate_tmp = new Date(startDate_tmp.split('T')[0]+"T00:00:00");
            }else{
                startDate_tmp = new Date(startDate_tmp);
            } 
        }
        
        var s = startTime === '' ? format(startDate_tmp, 'HH:mm') : startTime,
            parts = s.match(/(\d+)\:(\d+)/),
            hours = parseInt(parts[1], 10),
            minutes = parseInt(parts[2], 10);
        if(shiftLength === ''){
            shiftLength = "00:00";
        }

        let arrTime = shiftLength.split(':'); 
        let hrs = arrTime[0] && arrTime[0]!=='' ? arrTime[0] : 0; 
        let mins = arrTime[1] && arrTime[1]!=='' ? arrTime[1] : 0; 
        startDate_tmp.setHours(hours);
        startDate_tmp.setMinutes(minutes+Number(mins));
        startDate_tmp.setHours( startDate_tmp.getHours() + Number(hrs));
        endDate = format(startDate_tmp, 'yyyy-MM-dd')+" 00:00:00";
        endTime = format(startDate_tmp, 'HH:mm');
        this.setState({endDate,endTime, startTime, shiftLength});
    }

    onHandleChangeShiftLength = (time) =>{
        
        let {shiftLength} = this.state;
        if(time._d !== undefined){
            shiftLength = format(new Date(time._d), 'HH:mm');
            this.setState({shiftLength});
        }
        else {
            let timeStr = time.toString().trim();
            if(!checkNumColon(timeStr)) {
                timeStr = '00:00'; 
            }

            if(timeStr.indexOf(':') >=0 || timeStr!=='' || parseInt(timeStr,10) >= 0) {
                shiftLength = timeStr;
            }
            else if(timeStr==='') {
                shiftLength = '';
            }
            this.setState({shiftLength});
        }
    }

    onBlurShiftLength = (time) =>{
        let {shiftLength} = this.state;
        let slError = ''; 
        if(time._d !== undefined){
            shiftLength = format(new Date(time._d), 'HH:mm'); 
        }else{
            let timeStr = time.toString().trim();
            
            if(!checkNumColon(timeStr)) {
                timeStr = ''; 

            }

            if(timeStr.indexOf(':') >=0) {
                try{
                    var d = new Date(),
                        s = timeStr,
                        parts = s.match(/(\d+)\:(\d+)/),
                        hours = parseInt(parts[1], 10),
                        minutes = parseInt(parts[2], 10);

                    d.setHours(hours);
                    d.setMinutes(minutes);
                    shiftLength = format(d, 'HH:mm');
                }catch(err) {

                }
            }
            else if(timeStr==='') {
                shiftLength = '';
            }else{
                shiftLength = '';
            }
        } 
        this.setState({shiftLength});
        this.calculateEndDateAndTime();        
    }

    sendFilterData = () =>{
        let {startDate,endDate,startTime,endTime,skillIds,selectedDepartments,currentPage,perPageCount,selectedPayLevels} = this.state;
        if(selectedDepartments.length===0 || skillIds.length===0){
            this.setState({errorMessage:MSG_NO_DEPT_SKILL_SELECTED});
        }else{
            let startDateTime = startDate+" "+startTime+":00";
            let endDateTime = endDate+" "+endTime+":00";
            this.props.crewAvailSummaryReportListAction({departmentIds:selectedDepartments,
                                    skillIds:skillIds,startDateTime:startDateTime,
                                    endDateTime:endDateTime,page:1,pageSize:perPageCount,payLevelIds:selectedPayLevels});
        }   
    }

    componentDidMount() {
    	const { location } = this.props;
    	let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        } 
    	if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
        this.props.payLevelsListAction(); 
        this.props.serverTimeAction();
        this.props.crewAffSkillListAction({page:0,column:'skill_name',pageSize:''});
        this.props.aflt_departmentsListAction({page:0,column:'name',pageSize:'',associated:'1'}); 
        document.title = LBL_APP_NAME+" - "+LBL_CREW_AVAILABILITY; 
    }

    loadMultiSelPayLevels() {
        let allPL = []; 
        if(this.state.payLevelListAll.length > 0) {
           this.state.payLevelListAll.forEach((item,index) => { 
              allPL.push({value:item.id, label:titleCase(item.level_name), inputVal:0});
           }) 
           this.setState({payLevelMultiSelList:allPL}); 
        }
     } 

    componentDidUpdate (prevProps) {
        const {subactivity,skillList,crewProfileActivity,payLevelListAll,payLevelActivity,availabilitySummary} = this.props;
        
        if(this.props.payLevelActivity && this.props.payLevelActivity !== prevProps.payLevelActivity){
            let arrPL = this.props.payLevelActivity.split('~~');
            if(arrPL[0]===types.PAY_LEVELS_LIST_SUCCESS){
                this.setState({payLevelListAll:payLevelListAll}, () => {
                    this.loadMultiSelPayLevels(); 
                })
            }
        } 

        if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
                let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                let strDate = format(defaultEndDate, 'yyyy-MM-dd')+" 00:00:00"
                this.setState({defaultStartDate:defaultEndDate,defaultEndDate:defaultEndDate,
                            startDate:strDate,endDate:strDate})
            }
        } 
        if(subactivity && subactivity !== prevProps.subactivity) {
            let arrResp = subactivity.split('~~'); 
            let actString = arrResp[0]; 

            if(actString===types.CREW_AFFILIATE_SKILL_LIST_SUCCESS){
                //console.log('skillList'); 
                //console.log(skillList); 
                let skillMultiList = [];
                if(Array.isArray(skillList) && skillList.length>0){
                    skillList.forEach(item => {
                        skillMultiList.push({value:item.id,label:item.skill_name});
                    });
                }
                this.setState({skillMultiList});
            }else if(actString===types.CREW_AVAIL_SUMMARY_REPORT_SUCCESS){ 
                    this.setState({availabilitySummary:availabilitySummary,errorMessage:''});
            }
        }
        if(crewProfileActivity && crewProfileActivity !== prevProps.crewProfileActivity){
            let arrResp = crewProfileActivity.split('~~'); 
            let actString = arrResp[0]; 
            if(actString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS){
                if(this.props.hasOwnProperty('afltDepartmentsForCrew')) {
                    if(this.props.afltDepartmentsForCrew.length===0) {
                          this.setState({departmentsList: []}, () => {
                             this.loadMultiSelDeptValues(); 
                          } ); 
                    }
                    else {     
                          this.setState({departmentsList: this.props.afltDepartmentsForCrew}, () => {
                             this.loadMultiSelDeptValues(); 
                          } );                  
                    }
                }
            }
        }
    }

    

    render(){ 

        const {startDate,endDate,deptMultiSelList,skillMultiList,errorMessage,hasMore,payLevelMultiSelList,availabilitySummary} = this.state;

        let arrShiftStatus = SHIFT_STATUS; 

        let selectedStartDate = new Date(startDate)
        let selectedEndDate = new Date(endDate)
        let timeZone = getUserTimeZone(this.props.location);
    	return(
    		<React.Fragment>
    			<div className="col-md-12">
                    <div className="box col-md-12"> 
                        <div className="row">
                            <div className="form-group displayItemFlex marginBottomO">                           
                                <div className="col-md-3">
                                    <label>{LBL_SKILLS}</label>
                                    <div className="form-group multisel_textbox">
                                        <div className="form-group select-input skills" >
                                            <CustomMultiSelect id={'dept'} data={skillMultiList}  onChange={selected =>this.onskillDataChange(selected)} isTextBox={false} needSelectAll={true} />
                                        </div>
                                    </div>
                                </div> 
                                <div className="col-md-3">
                                    <label>{LBL_DEPARTMENTS}</label>
                                    <div className="form-group multisel_textbox">
                                        <div className="form-group select-input skills" >
                                            <CustomMultiSelect id={'dept'} data={deptMultiSelList}  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' needSelectAll={true} />
                                        </div>
                                    </div> 
                                </div>
                                <div className="col-md-3">
                                    <label>{LBL_PAY_LEVELS}</label>
                                    <div className="form-group multisel_textbox">
                                        <div className="form-group select-input skills" >
                                            <CustomMultiSelect id={'dept'} data={payLevelMultiSelList}  onChange={selected =>this.onChangePayLevelMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' needSelectAll={true} />
                                        </div>
                                    </div> 
                                </div>
                            </div> 
                        </div>
                    </div>
                    <div className="box col-md-12"> 
                        <div className="row">
                            <div className="form-group displayItemFlex marginBottomO"> 
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>{LBL_START_DATE}</label>
                                                <div className={'calendar-input'}>
                                                    <DatePicker 
                                                        selected={selectedStartDate}
                                                        onChange={selected =>this.onStartDateChange(selected)}
                                                        name="startDate"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select"
                                                        fixedHeight
                                                        minDate={new Date()}           
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label>{LBL_TIME}</label>
                                                <div className={'time-input'}>
                                                    <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'startTime'}}  value={this.state.startTime} onChange={selected=>this.onHandleChangeStartTime(selected)} onBlur={selected=>this.onBlurStartTime(selected)}
                                                    timeConstraints={ ENUM_MM5 } 
                                                    /> 
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="form-group"> 
                                        <div className="row">
                                            <div className="col-md-6">
                                            <div className="form-group"> 
                                                <label>{LBL_SHIFT_LENGTH}</label>
                                                <div className={'time-input'}>
                                                    <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: LBL_SELECT, name:'shiftLength'}}  value={this.state.shiftLength} onChange={selected=>this.onHandleChangeShiftLength(selected)}  onBlur={selected=>this.onBlurShiftLength(selected)} 
                                                    timeConstraints={ ENUM_SHIFT_LENGTH_HHMM }/> 
                                                </div>
                                            </div>
                                                
                                            </div>
                                            <div className="col-md-6">
                                            <label>{LBL_END_DATE}</label>
                                                <div className={'calendar-input text-optional'}>
                                                    <DatePicker 
                                                        selected={selectedEndDate}
                                                        onChange={selected =>this.onStartDateChange(selected)}
                                                        name="endDate"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select"
                                                        fixedHeight
                                                        disabled={true}           
                                                    />
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-3">
                                    <div className="form-group"> 
                                        <div className="row">
                                            <div className="col-md-6">
                                            <div className="form-group"> 
                                            <label>{LBL_TIME}</label>
                                                <div className={'time-input text-optional'}>
                                                    <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'endTime', disabled:true}}  value={this.state.endTime} onChange={selected=>this.onHandleChangeStartTime(selected)}  
                                                    timeConstraints={ ENUM_MM5 } 
                                                    /> 
                                                    
                                                </div>
                                            </div>
                                                
                                            </div>
                                            <div className="col-md-6 floatRight">
                                            <button type="button" className="btn btn-primary marginTop-25 floatRight" onClick={this.sendFilterData}>{LBL_SEARCH}</button>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                </div>
                            </div>
                    </div>
                    
                    
                </div>

                <div className="col-md-12 min-height-50VH margin-top-1rem">

                    { errorMessage && availabilitySummary.length <=0 &&
                        <div className={'box col-md-12 pl-0 pr-0 bg-white'}>
                            <div className="crew-list__noitem">{errorMessage}</div>
                        </div> }  

                    { errorMessage==='' && availabilitySummary  && 
                        <div className="dash-row">
                            
                            <div className="dash-col4 form-group">
                                <div className="card ">
                                    <div className="card-body padding-top-10">
                                        <div className='col-md-12 text-bold padding-left-0 report-items'>{LBL_SKILLS}</div>
                                        <hr className='hr-style-report'></hr>
                                        {availabilitySummary.skill_data && availabilitySummary.skill_data.map(skillItem => {
                                            return(<Row className='report-items'>
                                                <div className='col-md-9 padding-Bottom-5'><i className={'fas ' + skillItem.skill_icon}></i> {skillItem.skill_name}</div>
                                                <div className="col-md-3 padding-Bottom-5 align-right">{skillItem.count} </div>
                                            </Row>);
                                        })} 
                                    </div>
                                </div>
                            </div>
                             
                            <div className="dash-col4">
                                <div className="card ">
                                    <div className="card-body padding-top-10">
                                        <div className='col-md-12 text-bold padding-left-0 report-items'>{LBL_DEPARTMENTS}</div>
                                        <hr className='hr-style-report'></hr>
                                        {availabilitySummary.department_data && availabilitySummary.department_data.map(deptItem => {
                                            return(<Row className='report-items'>
                                                <div className='col-md-9 padding-Bottom-5'>{deptItem.name}</div>
                                                <div className="col-md-3 padding-Bottom-5 align-right">{deptItem.count} </div>
                                            </Row>);
                                        })} 
                                    </div>
                                </div>
                            </div> 

                            <div className="dash-col4">
                                <div className="card ">
                                    <div className="card-body padding-top-10">
                                        <div className='col-md-12 text-bold padding-left-0 report-items'>{LBL_SHIFT_STATUS}</div>
                                        <hr className='hr-style-report'></hr>
                                        {availabilitySummary.shift_status_data && availabilitySummary.shift_status_data.map(ssItem => {
                                            let filteredStatus = arrShiftStatus.filter(ss => Number(ss.statusCode)===Number(ssItem.status));
                                            return(<Row className='report-items'>
                                                <div className='col-md-9 padding-Bottom-5'>{filteredStatus[0].statusString+' ('+ssItem.shift_count+')'}</div>
                                                <div className="col-md-3 padding-Bottom-5 align-right">{ssItem.crews_needed} </div>
                                            </Row>);
                                        })} 
                                    </div>
                                </div>  
                            </div>

                            {availabilitySummary.pay_level_data && availabilitySummary.pay_level_data.length > 0 &&  <div className="dash-col4">
                                <div className="card ">
                                    <div className="card-body padding-top-10">
                                        <div className='col-md-12 text-bold padding-left-0 report-items'>{LBL_PAY_LEVELS}</div>
                                        <hr className='hr-style-report'></hr>
                                        {availabilitySummary.pay_level_data && availabilitySummary.pay_level_data.map(plItem => {
                                            return(<Row className='report-items'>
                                                <div className='col-md-9 padding-Bottom-5'>{plItem.level_name}</div>
                                                <div className="col-md-3 padding-Bottom-5 align-right">{plItem.count} </div>
                                            </Row>);
                                        })} 
                                    </div>
                                </div>
                            </div>} 

                        </div>}
                </div> 


    		</React.Fragment>
    	)
    }
}

const mapStateToProps = (state) => {
    console.log('availabilitySummary: ',JSON.stringify(state.event.availabilitySummary)); 
    return {
        subactivity:state.event.subactivity, 
        skillList:state.event.skillList,
        errorData:state.event.errorData,
        afltDepartmentsForCrew:state.crews.afltDepartmentsForCrew,
        aflt_departmentsListAction:aflt_departmentsListAction,
        crewProfileActivity:state.crews.crewProfileActivity,   
        availabilitySummary:state.event.availabilitySummary,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity,   
        payLevelListAll : state.payLevel.items,
        payLevelActivity:state.payLevel.subactivity,
    }
}           

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        crewAffSkillListAction:crewAffSkillListAction,
        aflt_departmentsListAction:aflt_departmentsListAction,
        crewAvailSummaryReportListAction:crewAvailSummaryReportListAction,
        serverTimeAction:serverTimeAction,
        payLevelsListAction:payLevelsListAction,  
    },dispatch);
}               


export default connect(mapStateToProps,mapDispatchToProps)(CrewAvailSummaryReportComponent);